module.exports = __webpack_public_path__ + "img/capa_59.74ac8de6.jpg";